import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/client`;

// Client Area API — cookie-based (withCredentials) + optional bearer token
export const clientApi = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

export const CLIENT_API_BASE = BASE;
